import { pathOr } from 'ramda';

import { Box, HStack, UserGroupBadge, VStack } from '@frontend/components';

import { partViewerRoutePrefix } from 'modules/viewerPage/data/routes';

import { useUserGroupBadgeLookup } from 'utils/multisite';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';

const PartMatchCell = ({
  partResult,
}: {
  partResult: { data: Record<string, any>; highlight: any };
}) => {
  const getBadgeProps = useUserGroupBadgeLookup();
  const badgeProps = getBadgeProps(partResult.data.ownerId);

  const primaryFile = pathOr([], ['data', 'partFiles'], partResult).find(
    (partFile: { isPrimaryFile: boolean }) => partFile.isPrimaryFile == true,
  );
  const { uuid: partFileUuid, filename, containsVirus } = primaryFile;
  const exportControlled = pathOr(
    null,
    ['data', 'exportControlled'],
    partResult,
  );

  return (
    <Box alignContent="left">
      <PartCell
        containsVirus={containsVirus}
        primaryFileUuid={partFileUuid}
        filename={filename}
        isExportControlled={exportControlled}
        partResult={partResult}
        resultOwnerId={partResult.data.ownerId}
        href={`${partViewerRoutePrefix}/${partResult.data.uuid}`}
      />
      {badgeProps && (
        <Box paddingTop={0.5}>
          <UserGroupBadge
            maxWidth="100%"
            size="sm"
            name={badgeProps.name}
            colorPalette={badgeProps.colorPalette}
            icon={badgeProps.icon}
          />
        </Box>
      )}
      <HStack paddingTop={0.5}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Process</LabelText>
          <LabelText>Material</LabelText>
          <LabelText>Finish</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay field="process" result={partResult} />
          <HighlightOrDisplay field="material" result={partResult} />
          <HighlightOrDisplay field="finishes" result={partResult} />
        </VStack>
      </HStack>
    </Box>
  );
};

export default PartMatchCell;
